export enum Role {
    SAMPLE_STUDIO_ADMIN = 'SAMPLE_STUDIO_ADMIN',
    SAMPLE_STUDIO_MAINTAINER = 'SAMPLE_STUDIO_MAINTAINER',
    SAMPLE_STUDIO_PROCESS_OWNER = 'SAMPLE_STUDIO_PROCESS_OWNER',
    SAMPLE_STUDIO_PRODUCER = 'SAMPLE_STUDIO_PRODUCER',
    SAMPLE_STUDIO_RETAILER = 'SAMPLE_STUDIO_RETAILER',
    SAMPLE_STUDIO_READ_ONLY = 'SAMPLE_STUDIO_READ_ONLY',
}
